import { render } from "./CollectionDetailedSearchOnlinePublications.vue?vue&type=template&id=7a2f3d50&scoped=true&ts=true"
import script from "./CollectionDetailedSearchOnlinePublications.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchOnlinePublications.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchOnlinePublications.vue?vue&type=style&index=0&id=7a2f3d50&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a2f3d50"]])

export default __exports__